import { Component, Input, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styleUrls: ['./copy-to-clipboard.component.scss']
})
export class CopyToClipboardComponent implements OnInit {

  @Input() textToCopy!:string;

  constructor(private clipboard: Clipboard) { }

  ngOnInit(): void {
  }

  copyToClipboard(copyText:string){
    this.clipboard.copy(copyText);
  }

}
